<template>
  <v-data-table
      :headers="headersP"
      :items="selectedMenuProducts"
      :search="search"
      class="elevation-1"
      item-key="product_id"
  >
    <template v-slot:top>
      <v-toolbar flat>

        <v-toolbar-title>
          <div class="text-subtitle-2">
            Menu Products
          </div>
          <div class="text-h5 font-italic">
            {{ selMenu.menu_name }}
          </div>
        </v-toolbar-title>

        <v-spacer></v-spacer>

        <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            hide-details
            label="Search Product"
            single-line
        ></v-text-field>

        <v-spacer></v-spacer>

        <v-dialog v-model="dialog" max-width="700px">
          <template v-if="editingMode" v-slot:activator="{ on, attrs }">
            <v-btn
                v-bind="attrs"
                v-on="on"
                class="mb-2"
                color="primary"
                dark
            >
              New Product
            </v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span class="headline">{{ formTitle }}</span>
            </v-card-title>

            <!--
              Alerts & Loaders
            -->
            <!--<Alerts :aType.sync="response" :productsMenu="alert"/> -->

            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" md="4" sm="6">
                    <div>
                      <v-autocomplete
                          v-model="selectedProductId"
                          :disabled="editedIndex > -1"
                          :items="productsToSelect"
                          auto-select-first
                          clearable
                          item-text="product_name"
                          item-value="_id"
                          label="Product"

                      >
                      </v-autocomplete>
                      <p v-if="$v.selectedProductId.$model === '' && !$v.selectedProductId.required"
                         style="color: red;">Please select a product.</p>
                    </div>
                  </v-col>
                  <v-col cols="12" md="4" sm="6">
                    <div>
                      <v-autocomplete
                          v-model="editedItem.product_category"
                          :disabled="editedIndex > -1"
                          :items="categories"
                          item-value="category_name"
                          label="Category"
                          single-line
                          @blur="!$v.editedItem.product_category.$touch()"
                          @update:search-input="updateProductsByCategory"
                      ></v-autocomplete>
                      <p v-if="$v.editedItem.product_category.$model === '' && !$v.editedItem.product_category.required"
                         style="color: red;">Please select a category.</p>
                    </div>
                  </v-col>
                  <v-col cols="12" md="4" sm="6">
                    <div>
                      <v-text-field
                          v-model="editedItem.product_price"
                          label="Price"
                          @blur="!$v.editedItem.product_price.$touch()"
                      ></v-text-field>
                      <p v-if="!$v.editedItem.product_price.check_price 
                        || ($v.editedItem.product_price.$model === ''
                        && $v.editedItem.product_price.required)" style="color: red;">
                        Please provide a numeric value.
                      </p>
                    </div>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                  color="blue darken-1"
                  text
                  @click="close"
              >
                Cancel
              </v-btn>
              <v-btn
                  :disabled="!$v.$anyDirty"
                  color="blue darken-1"
                  text
                  @click="save"
              >
                Save
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialogDelete" max-width="550px">
          <v-card>
            <v-card-title class="headline">Are you sure you want to remove this product?</v-card-title>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="closeDelete">Cancel</v-btn>
              <v-btn color="blue darken-1" text @click="deleteItemConfirm">OK</v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>

      </v-toolbar>
    </template>


    <template v-if="editingMode" v-slot:[`item.actions`]="{ item }">
      <v-icon
          class="mr-2"
          small
          @click="editItem(item)"
      >
        mdi-pencil
      </v-icon>
      <v-icon
          small
          @click="deleteItem(item)"
      >
        mdi-delete
      </v-icon>
    </template>
  </v-data-table>


</template>
<script>
import _ from "underscore";

import {required, helpers} from 'vuelidate/lib/validators';

//Check if the price is valid
const check_price = helpers.regex('numeric', /([0-9]*[.])?[0-9]+/);

export default {
  props: ['selMenu', 'editingMode', 'categories_list', 'products_list'],
  components: {

  },
  data: () => ({
    response: null,
    alert: false,

    dialog: false,
    dialogDelete: false,
    search: '',

    categories: [],
    productsToSelect: [],
    productsToSelectAvailable: [],

    selectedProductId: '',
    headersP: [],
    selectedMenuProducts: [],
    selectedMenuProductsIndexed: new Map(),
    editedIndex: -1,
    editedItem: {
      product_name: '',
      product_category: '',
      product_price: 0.0,
      product_id: ''
    },
    defaultItem: {
      product_name: '',
      product_category: '',
      product_price: 0.0,
      product_id: ''
    },
  }),
  validations: {
    selectedProductId: {
      required
    },
    editedItem: {
      product_name: {
        required
      },
      product_category: {
        required
      },
      product_price: {
        check_price,
        required
      }
    }
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? 'New Product' : 'Edit Product'
    },
  },

  watch: {
    dialog(val) {
      val || this.close()
    },
    dialogDelete(val) {
      val || this.closeDelete()
    },
    selMenu(val) {
      this.selectedMenuProducts = val.menu_products

    }
  },

  created() {
    this.initialize()

  },

  methods: {
    hasDuplicates() {

      let found = this.productsToSelect.find((product) => product._id === this.selectedProductId);
      if (found && !this.selectedMenuProductsIndexed.has(found._id)) {

        this.editedItem.product_name = found.product_name;
        this.editedItem.product_id = found._id;


        return false;
      } else {

        return true;


      }

    },

    updateProductsByCategory() {

      this.productsToSelect = this.products[this.editedItem.product_category];

      //TODO: If the suggested alternative for editing the product isn't accepted
      // let products = new Set(this.productsToSelect);

      // let a = new Set(Array.from(this.selectedMenuProductsIndexed.keys()));

      // this.productsToSelectAvailable = [...new Set([...products].filter(product => !a.has(product._id)))];


    },


    initialize() {

      this.headersP = this.editingMode ? [
        {
          text: 'Name',
          align: 'left',
          sortable: true,
          value: 'product_name'
        },
        {
          text: 'Category',
          sortable: true,
          value: 'product_category'
        },
        {
          text: 'Price (€)',
          sortable: true,
          value: 'product_price'
        },
        {
          text: 'Actions',
          sortable: false,
          value: 'actions'
        }
      ] : [
        {
          text: 'Name',
          align: 'left',
          sortable: true,
          value: 'product_name'
        },
        {
          text: 'Category',
          sortable: true,
          value: 'product_category'
        },
        {
          text: 'Price (€)',
          sortable: true,
          value: 'product_price'
        },];

      this.selectedMenuProducts = this.selMenu.menu_products
      this.selectedMenuProducts.forEach((product) => this.selectedMenuProductsIndexed.set(product.product_id, product))
      if (this.categories_list)
        this.categories = this.categories_list.map(cat => cat.name);
      if (this.products_list)
        this.products = _.groupBy(this.products_list, (elem) => elem.product_category);
    },

    editItem(item) {
      this.editedIndex = this.selectedMenuProducts.indexOf(item)
      this.productsToSelect = this.products[item.product_category];
      this.editedItem = Object.assign({}, item)
      if (item.product_id.length > 0)
        this.selectedProductId = item.product_id;
      this.dialog = true
    },

    deleteItem(item) {
      this.editedIndex = this.selectedMenuProducts.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialogDelete = true
    },

    deleteItemConfirm() {
      this.selectedMenuProducts.splice(this.editedIndex, 1)
      this.selectedMenuProductsIndexed.delete(this.editedItem.product_id);
      this.selMenu.menu_products = this.selectedMenuProducts;
      this.$emit('update-menu', this.selMenu.menu_products);


      this.response = 200;
      this.alert = true;

      this.closeDelete()
    },

    close() {
      this.dialog = false
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem)

        this.selectedProductId = ''
        this.editedIndex = -1

      })
    },

    closeDelete() {
      this.dialogDelete = false
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      })
    },

    save() {
      if (this.editedIndex > -1) {
        Object.assign(this.selectedMenuProducts[this.editedIndex], this.editedItem);
      } else {
        if (!this.hasDuplicates()) {

          this.selectedMenuProducts.push(this.editedItem);
          this.selectedMenuProductsIndexed.set(this.editedItem.product_id, this.editedItem);
        } else {
          alert("Product already exists!");
          return;

        }


      }
      this.selMenu.menu_products = this.selectedMenuProducts;

      this.$emit('update-menu', this.selMenu.menu_products);

      this.close()


    },
  },
}
</script>